import React from 'react';
import classNames from 'classnames';

export default function Toggle({
  id,
  name,
  checked = false,
  onChange,
  disabled = false,
  className = '',
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
  'aria-describedby': ariaDescribedBy,
}) {
  const handleChange = (event) => {
    if (onChange) {
      onChange(event.target.checked, event);
    }
  };

  return (
    <label
      className={classNames(
        'relative inline-flex h-6 w-11 shrink-0 items-center',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
    >
      <input
        id={id}
        name={name}
        type="checkbox"
        role="switch"
        className="peer sr-only"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
      />
      <span
        aria-hidden="true"
        className="absolute inset-0 rounded-full bg-white/10 transition-colors duration-200 ease-in-out peer-checked:bg-indigo-600 peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-indigo-500 peer-disabled:bg-white/5"
      />
      <span
        aria-hidden="true"
        className="absolute left-0.5 top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform duration-200 ease-in-out peer-checked:translate-x-5"
      />
    </label>
  );
}
